/**
 * Returns a react-icons icon name suggestion based on file extension.
 * Used to pick the right icon for FileMessage component.
 */

type FileCategory = 'image' | 'video' | 'audio' | 'pdf' | 'spreadsheet' | 'document' | 'archive' | 'code' | 'unknown'

const extensionMap: Record<string, FileCategory> = {
  // Images
  jpg: 'image', jpeg: 'image', png: 'image', gif: 'image', svg: 'image', webp: 'image',
  // Video
  mp4: 'video', avi: 'video', mov: 'video', mkv: 'video', webm: 'video',
  // Audio
  mp3: 'audio', wav: 'audio', ogg: 'audio', flac: 'audio',
  // Documents
  pdf: 'pdf',
  doc: 'document', docx: 'document', txt: 'document', rtf: 'document',
  xls: 'spreadsheet', xlsx: 'spreadsheet', csv: 'spreadsheet',
  ppt: 'document', pptx: 'document',
  // Archives
  zip: 'archive', rar: 'archive', '7z': 'archive', tar: 'archive', gz: 'archive',
  // Code
  js: 'code', ts: 'code', jsx: 'code', tsx: 'code', py: 'code', json: 'code', html: 'code', css: 'code',
  // Design
  figma: 'document', sketch: 'document', psd: 'image',
}

export function getFileCategory(filename: string): FileCategory {
  const ext = filename.split('.').pop()?.toLowerCase() ?? ''
  return extensionMap[ext] ?? 'unknown'
}

const sizeNumber = new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 1 })

/**
 * Розмір файлу: «7,8 КБ», «1,2 МБ» — з десятковою комою й українськими
 * одиницями, як решта чисел і розмірів в інтерфейсі.
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} Б`
  if (bytes < 1024 * 1024) return `${sizeNumber.format(bytes / 1024)} КБ`
  if (bytes < 1024 * 1024 * 1024) return `${sizeNumber.format(bytes / (1024 * 1024))} МБ`
  return `${sizeNumber.format(bytes / (1024 * 1024 * 1024))} ГБ`
}
